(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('SecurityEventsController', ["$scope", "securityEventStates", "securityEventTypes", "tablePaginationHelper", "securityEventsDao", "defaultListConverter", "$location", "base64", "timeResolutions", "$timeout", "modulesDao", "modulesManager", function ($scope, securityEventStates, securityEventTypes, tablePaginationHelper, securityEventsDao, defaultListConverter, $location, base64, timeResolutions, $timeout, modulesDao, modulesManager) {
        $scope.chartsWidget = {};
        $scope.listWidget = {};
        $scope.model = {
            resolution: 'month',
            filterBy: '',
            filters: [
                {
                    id: 'new',
                    type: 'current_state'
                },
                {
                    id: 'remediated',
                    type: 'current_state'
                },
                {
                    id: 'detected',
                    type: 'current_state'
                }
            ]
        };
        function preloadFilters() {
            var passedQueries = '';
            if ($location.search().filters) {
                try {
                    passedQueries = JSON.parse(base64.decode($location.search().filters));
                } catch (e) {
                    console.log('Error on parsing url query...');
                }
                if (passedQueries) {
                    $scope.model = passedQueries;
                }
            }
        }
        $scope.loadedModules = false;
        modulesManager.init().then(function () {
            _(securityEventTypes.defaultTypes()).each(function (type) {
                $scope.model.filters.push({
                    id: type,
                    type: 'type'
                });
            });
            preloadFilters();
            $scope.loadedModules = true;
        });
        $scope.secEventsApi = {
            updateFilter: function (type, variant, noReload) {
                var nextFilters = null;
                if (variant.removeAll) {
                    nextFilters = _($scope.model.filters).filter(function (filter) {
                        return filter.type !== type;
                    });
                } else {
                    var id = variant.id;
                    var found = _($scope.model.filters).find(function (filter) {
                        return filter.type === type && filter.id === id;
                    });
                    if (!found) {
                        nextFilters = $scope.model.filters.slice(0);
                        nextFilters.push({
                            type: type,
                            id: id
                        });
                    }
                }
                if (nextFilters) {
                    $scope.model.filters = nextFilters;
                    if (!noReload) {
                        $scope.secEventsApi.reload();
                    }
                }
            },
            setFilter: function (type, values, noReload) {
                values = values || [];
                var existing = _($scope.model.filters).chain().filter(function (filter) {
                    return filter.type === type;
                }).pluck('id').value();
                if (values.length !== existing.length || _(existing).intersection(values).length !== existing.length) {
                    var newFilters = _($scope.model.filters).filter(function (filter) {
                        return filter.type !== type;
                    });
                    _(values).each(function (val) {
                        newFilters.push({
                            type: type,
                            id: val
                        });
                    });
                    $scope.model.filters = newFilters;
                    if (!noReload) {
                        $scope.secEventsApi.reload();
                    }
                }
            },
            removeFilterByIndex: function (idx) {
                $scope.model.filters.splice(idx, 1);
                $scope.secEventsApi.reload();
            },
            clearAllFilters: function () {
                $scope.model.filters = [];
                $scope.secEventsApi.reload();
            },
            reload: function (params) {
                params = params || {
                    charts: true,
                    list: true
                };
                $timeout(function () {
                    $location.search('filters', base64.encode(JSON.stringify($scope.model)));
                    if (params.charts) {
                        $scope.chartsWidget.reload(true);
                    }
                    if (params.list) {
                        $scope.listWidget.reload(true);
                    }
                });
            }
        };
        modulesDao.getSecEntityNames().then(function (response) {
            $scope.secEntityNames = response.data;
        });
    }]);
}());